import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import Image from '../../resource/icon-png/Agrialert02.jpg';
import IF from '../IF';
import './index.less';

interface IProps {
    visible: boolean
    onCancel: () => void,
    onOk: () => void,
}

export default function HelpCarousel(props: IProps) {
    const {
        visible,
        onCancel,
        onOk
    } = props;
    const [currentIndex, setCurrentIndex] = useState(1);

    useEffect(() => {
        console.log(currentIndex);
    }, [currentIndex]);

    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            onOk={onOk}
            title={null}
            footer={
                <div className='footer-button'>
                    <button className='second-button' onClick={onCancel}>
                            Close
                    </button>

                </div>}
            className='carousel-modal'
            closeIcon={<span />}
        >
            <div style={{margin:'20px 0'}}>
                <img src={Image} className='image-step' />
            </div>
            <div>
                <span className='description-step'>
                The Agrialert Portal is designed to create recurring emails containing customized weather insights and agronomic decision recommendations.
                </span>
            </div>
        </Modal>
    );
}
